import { Icon } from '../types/icons';

export const jacketIcons: Icon[] = [
	{ key: 'blazer', url: 'https://cdn.easysize.me/icons/blazer-jacket-1.svg' },
	{ key: 'blazer-2', url: 'https://cdn.easysize.me/icons/blazer-jacket-2.svg' },
	{ key: 'coat-1', url: 'https://cdn.easysize.me/icons/coat-jacket-1.svg' },
	{ key: 'coat-2', url: 'https://cdn.easysize.me/icons/coat-jacket-2.svg' },
	{ key: 'outerwear', url: 'https://cdn.easysize.me/icons/outerwear-jacket.svg' },
]